import React from 'react';

// Styles & Assets
import styles from './EditColumnsDialog.module.css';

// Context
import ColumnsContext from '../../../context/ColumnsContext';

// Hooks
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

// Components
import CheckboxGrid from '../../UI/CheckboxGrid/CheckboxGrid';

// Interfaces 
interface Props {
    modalShow: React.Dispatch<React.SetStateAction<boolean>>
    sonarView: boolean
}


const EditColumnsDialog: React.FC<Props> = ({ modalShow, sonarView }) => {

    const { t } = useTranslation();

    const columnsContext = useContext(ColumnsContext);

    const changeVisibility = (id: number) =>
        columnsContext.dispatchColumns({ type: `TOGGLE_${!sonarView ? 'patient' : 'sonar'}_COLUMN_VISIBILITY`, id });


    return (
        <div className={`${styles.editColumnsDialogContainer} dialog`}>
            <h1 className='dialogTitle'>{t('select_data')}</h1>
            <div className={styles.editColumnsOptionsContainer}>
                <div className={styles.rowOptionsContainer}>
                    <h2 className='dialogSubTitle'>{!sonarView ? t('patients_list') : t('SONAR')}</h2>
                    <div className={styles.checkboxGridContainer}>
                        <CheckboxGrid
                            columns={!sonarView ? columnsContext.columnsPatients : columnsContext.columnsSonar}
                            toggleVisibility={changeVisibility}
                        />
                    </div>
                </div>
            </div>
            <div className={styles.bottomButtonContainer}>
                <button onClick={() => modalShow(false)} className={styles.bottomButton}>
                    {t('close')}
                </button>
            </div>
        </div>
    );
};

export default EditColumnsDialog;